import React, { FC } from 'react';
import { TextInput } from 'react-native';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { TimeTileProps } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles/components/TimeTile';
import { isWeb } from '@helpers';

export interface TimeTileInputProps extends Pick<TimeTileProps, 'C'> {
  value: string;
  onChangeText: (text: string) => void;
}

const TimeTileInput: FC<TimeTileInputProps> = ({ C, value, onChangeText }) => {
  return (
    <TextInput
      value={value}
      onChangeText={onChangeText}
      style={[
        font.Body,
        isWeb && { outline: 'none' },
        {
          color: C('Label/Light/Primary'),
          padding: 0,
          margin: 0,
          minWidth: scale(80),
        },
      ]}
      autoFocus
    />
  );
};

export default TimeTileInput;
